module.exports = __webpack_public_path__ + "img/132ab27.jpg";